import React from 'react';
import {ComposedModal, ModalHeader, ModalBody, ModalFooter, Button} from '@carbon/react';
import {WarningFilled} from '@carbon/icons-react';

export interface ContinuePartialDataModalProps {
    isOpen: boolean;
    rowsExcluded: number;
    onClose: () => void;
    onContinue: () => void;
}

export const ContinuePartialDataModal: React.FC<ContinuePartialDataModalProps> = ({
    isOpen,
    rowsExcluded,
    onClose,
    onContinue,
}) => {
    return (
        <ComposedModal open={isOpen} onClose={onClose} size="sm">
            <ModalHeader title="Continue with partial data?" />
            <ModalBody>
                <p style={{marginBottom: '1rem', fontSize: '0.875rem', color: '#161616'}}>
                    <strong>{rowsExcluded} rows</strong> will be excluded from this file.
                </p>
                <p style={{marginBottom: '1rem', fontSize: '0.875rem', color: '#525252', lineHeight: 1.5}}>
                    Excluded rows will not be included in the final output and cannot be recovered in this run.
                    Processing will continue with the remaining data.
                </p>
                <div
                    style={{
                        padding: '0.75rem 1rem',
                        background: '#fef6e6',
                        borderRadius: '4px',
                        borderLeft: '3px solid #f1c21b',
                    }}
                >
                    <p style={{margin: 0, fontSize: '0.8125rem', color: '#875500', lineHeight: 1.5}}>
                        <WarningFilled size={16} style={{verticalAlign: 'middle', marginRight: '0.5rem'}} />
                        <strong>Note:</strong> These rows will not be included in the final output and cannot be recovered in this run.
                        You can fix these issues later within the app once processing completes.
                    </p>
                </div>
            </ModalBody>
            <ModalFooter style={{justifyContent: 'space-between'}}>
                <Button kind="ghost" onClick={onClose}>
                    Cancel
                </Button>
                <Button kind="primary" onClick={onContinue}>
                    Continue Processing
                </Button>
            </ModalFooter>
        </ComposedModal>
    );
};
